/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UnsetAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import Tysiav2PatientRemoveIcon from 'DesignSystem/Svgs/Tysiav2PatientRemoveIcon/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function UnsetAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/PatientSelect/Content/Content/Existing/PatientPreview/Content/UnsetAction"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<button
  data-testid="UnsetAction.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<Tysiav2PatientRemoveIcon
  viewPath={`${viewPath}/Tysiav2PatientRemoveIcon`}
/>
</button>
{children}
</React.Fragment>)
}